import { Fragment, ReactNode } from 'react'
import { colors } from '../../tokens/colors.js'
import { Separator } from '../Separator/index.js'
import { Stack } from '../Stack/index.js'

type AppHeaderChildrenProps = {
  children: ReactNode
  variant?: 'main' | 'sub'
  showAccountSettings?: boolean
  showWorkspaceSettings?: boolean
}

const AppHeader = ({ children, variant = 'main' }: AppHeaderChildrenProps) => (
  <Stack
    justify="start"
    align="center"
    style={{
      padding: variant === 'main' ? '8px 16px' : 0,
      borderBottom:
        variant === 'main' ? `1px solid ${colors.neutral10}` : undefined,
      marginBottom: variant === 'sub' ? '16px' : '0px',
      width: '100%',
      gap: 8,
    }}
  >
    {children}
  </Stack>
)

type AppHeaderItemsProps = {
  children: ReactNode
  position: 'left' | 'right'
}

const AppHeaderItems = ({ children, position }: AppHeaderItemsProps) => (
  <Stack
    gap={8}
    fitContent
    style={{
      marginLeft:
        position === 'right' ? 'auto' : position === 'left' ? '0' : undefined,
    }}
  >
    {Array.isArray(children)
      ? children.filter(Boolean).map((child, index, array) => {
          if (index === array.length - 1) {
            return child
          }
          return (
            <Fragment key={index}>
              {child}
              <AppHeader.Separator />
            </Fragment>
          )
        })
      : children}
  </Stack>
)

const AppHeaderRight = ({ children }: AppHeaderChildrenProps) => (
  <AppHeaderItems position="right">{children}</AppHeaderItems>
)

const AppHeaderLeft = ({ children }: AppHeaderChildrenProps) => (
  <AppHeaderItems position="left">{children}</AppHeaderItems>
)

const AppHeaderSeparator = () => (
  <Separator orientation="vertical" style={{ height: 12 }} />
)

AppHeader.Right = AppHeaderRight
AppHeader.Left = AppHeaderLeft
AppHeader.Separator = AppHeaderSeparator

export { AppHeader }
